import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";

import desiredPromptsImage from "src/shared/assets/desiredPrompts.png";
import desiredPromptsGif from "src/shared/assets/gifSections/desiredPrompts.gif";

export const DesiredPrompts: React.FC = () => {
  return (
    <Stack width={1} direction="column" gap={1}>
      <Stack
        width={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography
          color="primary.contrastText"
          variant="h6"
          textTransform="uppercase"
          fontWeight={300}
          sx={{
            fontSize: {
              sm: "1.25rem",
              xs: "1rem",
            },
          }}
        >
          How it works
        </Typography>

        <Stack
          width={1}
          direction="row"
          justifyContent="center"
          alignItems="center"
          gap={1}
        >
          <Typography
            color="text.secondary"
            variant="h4"
            fontWeight={300}
            sx={{
              fontSize: {
                sm: "2.125rem",
                xs: "1.675rem",
              },
            }}
          >
            Use
          </Typography>
          <Typography
            color="primary"
            variant="h4"
            fontWeight={300}
            sx={{
              fontSize: {
                sm: "2.125rem",
                xs: "1.675rem",
              },
            }}
          >
            the magic!
          </Typography>
        </Stack>

        <Typography
          maxWidth={0.7}
          color="text.primary"
          variant="body1"
          textAlign="center"
          sx={{
            fontSize: {
              sm: "1rem",
              xs: "0.875rem",
            },
          }}
        >
          “Write Better” is the AI-powered writing assistant that helps you
          communicate more effectively and efficiently. Improve grammar,
          clarity, and style with a single click
        </Typography>
      </Stack>

      <Stack
        width={1}
        marginTop={6}
        direction="row"
        alignItems="center"
        gap={4}
        sx={{
          flexDirection: {
            md: "row",
            xs: "column-reverse",
          },
        }}
      >
        <Box
          sx={{
            width: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          <img width="100%" src={desiredPromptsGif} alt="desiredPromptsGif" />
        </Box>

        <Divider
          orientation="vertical"
          flexItem
          sx={{
            borderColor: "text.primary",
            flexDirection: {
              md: "flex",
              xs: "none",
            },
          }}
        />

        <Stack
          width={1}
          direction="column"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Stack
            width={1}
            direction="row"
            justifyContent="center"
            alignItems="center"
            gap={1}
          >
            <Typography color="primary" variant="h5">
              Getting
            </Typography>
            <Typography color="text.secondary" variant="h5">
              Desired Prompts
            </Typography>
          </Stack>

          <Typography
            maxWidth={0.7}
            color="text.primary"
            variant="body1"
            textAlign="center"
            marginBottom={4}
          >
            How is the user gets the desired prompt
          </Typography>

          <Box width={1}>
            <img
              width="100%"
              src={desiredPromptsImage}
              alt="desiredPromptsImage"
            />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};
